import React from 'react';
import { getFavoriteMarketsFromLS, useFavoriteMarketsDispatch } from '../live/favorite-markets/FavoriteMarketsProvider';
import Img from './Img';

export default function FavoriteButtonMarket(props) {
    const favoriteMarketsDispatch = useFavoriteMarketsDispatch();

    function handleClick(e) {
        e.stopPropagation();
        favoriteMarketsDispatch({
            type: 'toggle',
            id: props.id
        });
    }

    const favorites = getFavoriteMarketsFromLS('xs_favorite_markets');
    const toggled = favorites[props.id] != null;

    return (
        <div className="c_10_1_1" onClick={handleClick}>
            <Img className="c_10_1_1_1" src={`/favorites-${toggled ? 'on' : 'off'}.svg`} height="16px" width="16px" />
        </div>
    );
}
